import { ProfileMenu, ProfileSidebarMobile } from 'components';
import { PROFILE_ROUTES, ROUTES } from 'configs';
import {
  CancelSubscriptionPage,
  ChangePlanPage,
  EnterpriseCheckoutPage,
  NotificationsPage,
  PersonalChat,
  SubscriptionInner,
  UserProfileCalendarsPage,
  UserProfileCommunitiesPage,
  UserProfileEvents,
  UserProfilePage,
  UserProfileSettingsPage,
  UserProfileSubscriptionPage,
} from 'pages';
import React from 'react';
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useParams,
} from 'react-router-dom';
import { useMedia } from 'react-use';
import { breakpoints } from 'theme';

const ProfileRouter = () => {
  const isWide = useMedia(breakpoints.md);

  return (
    <>
      {isWide ? <ProfileMenu /> : <ProfileSidebarMobile />}
      <Routes>
        <Route index element={<UserProfilePage />} />
        <Route
          path={PROFILE_ROUTES.SETTINGS}
          element={<UserProfileSettingsPage />}
        />

        <Route
          path={PROFILE_ROUTES.CALENDAR_CONNECTION}
          element={<UserProfileCalendarsPage />}
        />

        <Route
          path={PROFILE_ROUTES.SUBSCRIPTION}
          element={<UserProfileSubscriptionPage />}
        />

        <Route
          path={PROFILE_ROUTES.COMMUNITIES}
          element={<UserProfileCommunitiesPage />}
        />

        <Route path={ROUTES.EVENTS} element={<UserProfileEvents />} />

        <Route
          path={PROFILE_ROUTES.NOTIFICATIONS}
          element={<NotificationsPage />}
        />
        <Route path={PROFILE_ROUTES.CHAT} element={<PersonalChat />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
        {/* <Route
          path={`${ROUTES.MESSAGE}/:userId`}
          element={<PrivateChatPage />}
        /> */}
      </Routes>
    </>
  );
};

export default ProfileRouter;
